import React from 'react';
import { Box, Container, Typography, Grid, Link } from '@mui/material';
import { Phone, Email, LocationOn } from '@mui/icons-material';
import { siteConfig } from '../config/siteConfig';

const Footer = () => {
  return (
    <Box sx={{ bgcolor: siteConfig.colors.secondary, color: 'white', py: 6, mt: 8 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
              {siteConfig.companyName}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Ihr Spezialist für professionelles Chiptuning mit über 18 Jahren Erfahrung.
            </Typography>
            <Typography variant="body2">
              Modernste Technologie und höchste Qualitätsstandards.
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
              Kontakt
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Phone sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2">{siteConfig.contact.phone}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Email sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2">{siteConfig.contact.email}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <LocationOn sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2">{siteConfig.contact.locations.join(', ')}</Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
              Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="#" color="inherit" underline="hover">Home</Link>
              <Link href="#" color="inherit" underline="hover">Services</Link>
              <Link href="#" color="inherit" underline="hover">Fahrzeuge</Link>
              <Link href="#" color="inherit" underline="hover">Über uns</Link>
              <Link href="#" color="inherit" underline="hover">Kontakt</Link>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.2)', mt: 4, pt: 3, textAlign: 'center' }}>
          <Typography variant="body2">
            © {new Date().getFullYear()} {siteConfig.companyName}. Alle Rechte vorbehalten.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
